import React from "react";
import Snackbar from "@mui/material/Snackbar";
import {
    CheckCircle2,
    CircleAlert,
    Info,
    TriangleAlert,
    X,
} from "lucide-react";
import "./snackBar.css";

const TOAST_META = {
    success: {
        title: "Success",
        icon: CheckCircle2,
    },
    error: {
        title: "Something went wrong",
        icon: CircleAlert,
    },
    warning: {
        title: "Attention required",
        icon: TriangleAlert,
    },
    info: {
        title: "Information",
        icon: Info,
    },
};

const CustomSnackbar = ({ open, message, severity = "info", onClose }) => {
    const meta = TOAST_META[severity] || TOAST_META.info;
    const Icon = meta.icon;

    const handleClose = (event, reason) => {
        if (reason === "clickaway") return;
        onClose?.(event, reason);
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            className="mp-toast-host"
        >
            <div className={`mp-toast mp-toast-${severity}`} role="alert">
                <span className="mp-toast-icon" aria-hidden="true">
                    <Icon size={19} strokeWidth={2.2} />
                </span>

                <span className="mp-toast-copy">
                    <strong>{meta.title}</strong>
                    <span>{message}</span>
                </span>

                <button
                    type="button"
                    className="mp-toast-close"
                    aria-label="Dismiss notification"
                    onClick={handleClose}
                >
                    <X size={16} />
                </button>
            </div>
        </Snackbar>
    );
};

export default CustomSnackbar;
